function checkName(name: string): boolean {
  const verifyName = name.trim();

  const nameIsValid =
    verifyName.split(' ').every((element) => element && element.length > 0) &&
    verifyName.split(' ').length >= 2;
  return nameIsValid;
}

function checkCpf(cpf: string): boolean {
  const inputCPF = cpf.replace(/[^\d]+/g, '');
  let soma = 0;
  let resto: number;
  if (inputCPF === '00000000000') return false;
  for (let i = 1; i <= 9; i += 1) soma += parseInt(inputCPF.substring(i - 1, i), 10) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(inputCPF.substring(9, 10), 10)) return false;
  soma = 0;
  for (let i = 1; i <= 10; i += 1) soma += parseInt(inputCPF.substring(i - 1, i), 10) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(inputCPF.substring(10, 11), 10)) return false;
  return true;
}

function checkPhone(phone: string): boolean {
  const inputPhone = phone.replace(/[^a-zA-Z0-9]/g, '').replace(' ', '');

  if (inputPhone.length !== 11) {
    return false;
  }
  return true;
}

export const checkAllInputs = (name: string, cpf: string, phone: string): string => {
  const nameIsValid = checkName(name);
  const cpfIsValid = checkCpf(cpf);
  const phoneIsValid = checkPhone(phone);

  if (!nameIsValid)
    return 'Digite nome, sobrenome e verifique se não há espaços em branco além do necessário!';
  if (!cpfIsValid) return 'Digite um CPF válido!';
  if (!phoneIsValid) return 'Digite um telefone válido!';

  return 'All inputs are valid!';
};
